import { AppIntegrationsRepository } from 'common/repositories/index';
import Util from '../services/util/-RFC.util.js';

/**
 * Integrations Processor
 */


const AppIntegrationsProcessor = {

    /**
     * Checks if the appintegration received
     * is bundle and contains more than one app and browsers extensions
     * Also check if the received os matched the app supported os
     * @param {any} AppIntegration AppIntegration
     * @param {any} os os
     *
     */
    checkIfTrueBundle(AppIntegration, os) {

        if (AppIntegration.attributes.type === 'bundle') {

            const bundleApps = Util.deepFind(AppIntegration, 'relationships.apps.data');

            const filteredBundleApps = bundleApps.filter((bundleApp) => {

                const appData = AppIntegrationsRepository.getById(bundleApp.id);

                // check if the bundle app is not a browser extension
                const isNotBrowserExtension = !Util.deepFind(appData, 'attributes.custom.manifest.browsers');

                const bundleAppOS = Util.deepFind(appData, 'attributes.custom.manifest.os') || ['windows'];
                // check if received os is supported by the app
                const matchesOs = bundleAppOS.indexOf(os) > -1;

                return isNotBrowserExtension && matchesOs;

            });

            return filteredBundleApps.length > 1;

        }

        return false;

    },

};

export default AppIntegrationsProcessor;



// WEBPACK FOOTER //
// ./scripts/common/repositoryProcessors/-RFC.appIntegrationsProcessor.js